"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ciro": {
    "6a2f9cb5": [{
      "hkey": "6a40df29",
      "slug": "cappella",
      "name": "Cappella",
      "primary": true,
      "skipSearch": false
    }],
    "capella": [{
      "hkey": "6a40df29",
      "slug": "cappella",
      "name": "Cappella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "76568a62": [{
      "hkey": "d5ffc03b",
      "slug": "ciro",
      "name": "Cirò",
      "primary": true,
      "skipSearch": false
    }],
    "cappelleri": [{
      "hkey": "d5ffc03b",
      "slug": "ciro",
      "name": "Cirò",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1f0aa776": [{
      "hkey": "d5ffc03b",
      "slug": "ciro",
      "name": "Cirò",
      "primary": true,
      "skipSearch": false
    }],
    "casale-attiva": [{
      "hkey": "d5ffc03b",
      "slug": "ciro",
      "name": "Cirò",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "29989ab0": [{
      "hkey": "d5ffc03b",
      "slug": "ciro",
      "name": "Cirò",
      "primary": true,
      "skipSearch": false
    }],
    "nuclei-abitati-sparsi-localita-toscano": [{
      "hkey": "d5ffc03b",
      "slug": "ciro",
      "name": "Cirò",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;